import { useApi } from '@/api';
import {
  ActivityCard,
  EntityName,
  ExternalLinkIcon,
  KpiCard,
  LinkButton,
  Page,
  PageSkeleton
} from '@/components';
import { STABLECOIN_ETHERSCAN_MAPPING } from '@/constants';
import {
  CryptoIcon,
  EtherScanPictogram,
  Flex,
  Heading
} from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricTabs from './HistoricTabs';
import LitePSMHistoricTabs from './LitePSMHistoricTabs';
import LitePSMKpis from './LitePSMKpis';

export default function StablecoinILKPage() {
  const { ilk } = useParams();
  const [data, error] = useApi({
    url: `/groups/stablecoins/ilks/${ilk}/`,
    queryParams: {
      days_ago: 1
    }
  });

  if (error) {
    throw error;
  }
  if (data) {
    const title = (
      <EntityName
        symbol1={
          <CryptoIcon
            name={data.collateral_symbol}
            address={data.collateral_address}
            size="6"
          />
        }>
        <Flex gap="3xs" flexDirection="column">
          <Flex gap="3xs">
            <Heading size="1">{data.name}</Heading>
          </Flex>
          <Flex gap="3xs" color="muted">
            {data.ilk}
            {STABLECOIN_ETHERSCAN_MAPPING[data.ilk] && (
              <a
                href={`https://etherscan.io/address/${STABLECOIN_ETHERSCAN_MAPPING[data.ilk]}`}
                target="_blank"
                rel="noreferrer">
                <EtherScanPictogram size="0" />
              </a>
            )}
          </Flex>
        </Flex>
      </EntityName>
    );

    return (
      <Page
        title={title}
        actions={
          data.ilk === 'LITE-PSM-USDC-A' && (
            <>
              <LinkButton
                to="https://litepsm.blockanalitica.com/"
                target="_blank">
                <Flex
                  gap="3xs"
                  alignItems="center"
                  style={{ whiteSpace: 'nowrap' }}>
                  LitePSM Details
                  <ExternalLinkIcon size="1" />
                </Flex>
              </LinkButton>
            </>
          )
        }>
        {data.ilk === 'LITE-PSM-USDC-A' && <LitePSMKpis daysAgo={1} />}
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Debt"
            variant="dai"
            data={data}
            field="debt"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'DAI'
                }
              }
            }}
          />
        </Flex>
        {ilk === 'LITE-PSM-USDC-A' ? (
          <LitePSMHistoricTabs ilk={ilk} />
        ) : (
          <HistoricTabs ilk={ilk} />
        )}

        <ActivityCard
          url={`/groups/stablecoins/ilks/${ilk}/activity/`}
          linkTo="activity"
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
